import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { payoutSchema, payoutListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import {
  loadingStart,
  loadingFinish,
  actionConfirmed,
} from 'app/ducks/loading/actions';
import {
  sagaActions,
} from 'app/ducks/payouts/actions';
import { PayoutsActionTypes as types } from 'app/ducks/payouts/types';

function* createPayoutSaga(action): any {
  yield put(sagaActions.createPayoutPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamPayouts.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, payoutSchema);

    yield put(sagaActions.createPayoutSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPayoutFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updatePayoutSaga(action): any {
  yield put(sagaActions.updatePayoutPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamPayouts.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, payoutSchema);

    yield put(sagaActions.updatePayoutSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updatePayoutFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* deletePayoutSaga(action): any {
  yield put(sagaActions.deletePayoutPending(action.payload.id));
  const [error, response] = yield (yield TeammoApi(yield select())).teamPayouts.delete(
    action.payload,
  );

  if (response || _.isEmpty(error)) {
    // const normalizedResponse = normalize(response, payoutSchema);
    yield put(sagaActions.deletePayoutSuccess(action.payload.id));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.deletePayoutFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getPayoutSaga(action): any {
  yield put(sagaActions.getPayoutPending());
  const [error, response] = yield (yield TeammoApi(yield select())).teamPayouts.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, payoutSchema);
    yield put(sagaActions.getPayoutSuccess(normalizedResponse));
    return normalizedResponse.entities.payouts[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getPayoutFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllPayoutsSaga(action): any {
  yield put(
    sagaActions.getAllPayoutsPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.payouts.pagination))
    : action.payload.pagination;
  const teammoApi = TeammoApi(yield select());

  const [error, response] = yield (yield teammoApi).teamPayouts.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, payoutListSchema);

    yield put(
      sagaActions.getAllPayoutsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(error, sagaActions.getAllPayoutsFailed(_.isEmpty(error) ? {} : error.response.data.errors));
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createPayoutSagaWatcher(): any {
  yield takeLatest(types.CREATE_PAYOUT_REQUESTED, createPayoutSaga);
}

function* updatePayoutSagaWatcher(): any {
  yield takeLatest(types.UPDATE_PAYOUT_REQUESTED, updatePayoutSaga);
}

function* deletePayoutSagaWatcher(): any {
  yield takeLatest(types.DELETE_PAYOUT_REQUESTED, deletePayoutSaga);
}

function* getPayoutSagaWatcher(): any {
  yield takeLatest(types.GET_PAYOUT_REQUESTED, getPayoutSaga);
}

function* getAllPayoutsSagaWatcher(): any {
  yield takeLatest(types.GET_ALL_PAYOUTS_REQUESTED, getAllPayoutsSaga);
}

export default function* root(): any {
  yield all([
    createPayoutSagaWatcher(),
    updatePayoutSagaWatcher(),
    deletePayoutSagaWatcher(),
    getPayoutSagaWatcher(),
    getAllPayoutsSagaWatcher(),
  ]);
}
